import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APGenericSlot } from './ap_generic_slot_builder';
import { APTermSlotGroup } from './ap_term_slot_group_builder';

export interface IAPYearSlotGroupMeta extends IIndexable {
  _term_slot_group: APTermSlotGroup[];
  _programSlots: APGenericSlot[];
}

export class APYearSlotGroup {
  id: number;
  name: string;
  nk: string;
  rank: number;

  constructor(slot: Partial<APYearSlotGroup>) {
    _4.merge(this, {}, slot);
  }

  static build(slot: Partial<APYearSlotGroup>): APYearSlotGroup {
    return new APYearSlotGroup(slot);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_year_slot_group_builder.ts